import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { NavLink } from 'react-router-dom'

class ButtonPrimary extends React.Component {
  renderClick(e) {
    e.preventDefault();

    this.props.onClick();
  }

  render() {
    return (
      <NavLink className={classnames('btn-primary', this.props.className)} to={ this.props.to }>{this.props.children}</NavLink>
    )
  }
}

ButtonPrimary.propTypes = {
  to: PropTypes.string
}

export default ButtonPrimary;



// WEBPACK FOOTER //
// ./src/components/buttons/primary/index.js